import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss']
})
export class EmptyStateComponent {
  @Input() icon = 'ri-inbox-line';
  @Input() title = 'Sem dados';
  @Input() message = 'Não existem registos para mostrar.';
  @Input() appearance: 'default' | 'orbit' = 'default';
  @Input() actionLabel: string | null = null;
  @Input() actionIcon = 'ri-add-line';
  @Output() action = new EventEmitter<void>();
}
